import * as yup from 'yup';
// eslint-disable-next-line import/no-extraneous-dependencies
import { isValid } from 'date-fns';
import { yupResolver } from '@hookform/resolvers/yup';
var schema = yup.object().shape({
    person: yup.object().shape({
        firstName: yup.string().required('This field is required.'),
        lastName: yup.string().required('This field is required.'),
        dateOfBirth: yup
            .date()
            .nullable()
            .typeError(' ')
            .test('Has valid date', ' ', function (_, _a) {
            var originalValue = _a.originalValue;
            return originalValue ? isValid(originalValue) : true;
        }),
        email: yup.string().email('This field must be a valid email address.'),
        phones: yup.array().of(yup.object().shape({
            phoneNumber: yup
                .string()
                .test('Required preferred phone', 'This field is required.', 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function (value, _a) {
                var index = _a.options.index;
                return index > 0 || !!value;
            })
                .matches(/^\(\d{3}\)\s\d{3}-\d{4}$|^\d{10}$/, {
                message: 'Invalid Phone Number.',
                excludeEmptyString: true
            })
        })),
        address: yup.object().shape({
            zipcode: yup.string().matches(/\b\d{5}\b/, {
                message: 'Invalid zip code.',
                excludeEmptyString: true
            })
        })
    })
});
export default yupResolver(schema);
//# sourceMappingURL=customerProfile.schema.js.map